import React from 'react';
import { capitalizeFirstLetter } from '../../../util/genericHelpers';
import { TalentPlusService } from '../../../util/enums';
import { FormattedMessage } from 'react-intl';
import { Icons, PrimaryButton } from '../../../components';
import classNames from 'classnames';
import css from './Sections.module.css';
import { getTalentServiceDescription } from '../../../config/configExtras';

const SocialMediaSection = ({ talentPlus, title }) => {
  const mentorship = talentPlus?.filter(
    service => service?.service === TalentPlusService.SOCIAL_MEDIA
  );

  const availableItems =
    mentorship?.map(mentorShip => ({
      title:
        mentorShip.type === 'Custom' ? mentorShip.service : capitalizeFirstLetter(mentorShip.type),
      price: mentorShip.price,
    })) || [];

  return (
    <>
      <div className={css.getCustomVideo}>
        <h2>
          <FormattedMessage id="EnhancedServices.SocialMediaSection.modelTitle" />{' '}
          <FormattedMessage id="SectionAppearances.from" values={{ title }} />
        </h2>
      </div>
      {availableItems.length > 0
        ? availableItems.map((item, idx) => (
            <div className={css.bookingSec} key={idx}>
              <div className={classNames(css.offerSec, css.withoutIconSec)}>
                <div className={css.offerContent}>
                  <h2>{item.title}</h2>
                  <p>${Number(item.price).toFixed(2)} per hour</p>
                  <p>{getTalentServiceDescription(item?.title)}</p>
                  <PrimaryButton className={css.bookBtn}>
                    <Icons name="security" />
                    <FormattedMessage id="EnhancedServices.SectionExclusedTraining.buyNowButton" />
                  </PrimaryButton>
                </div>
              </div>
            </div>
          ))
        : null}
    </>
  );
};

export default SocialMediaSection;
